import type { ReactNode } from "react"

import { tv, type VariantProps } from "@/lib/utils/tv"

const statusLabel = tv({
  base: "inline-flex h-7 items-center gap-150 rounded-full px-300 font-display text-overline uppercase",
  variants: {
    tone: {
      ready: "bg-statlabel-ready text-fg-inverted",
      progress: "bg-pink text-fg-inverted",
      review: "border border-line bg-surface text-fg",
      error: "bg-error-fill text-error-text",
      vip: "bg-vip-blue text-vip-gold",
    },
  },
  defaultVariants: { tone: "ready" },
})

export const StatusLabel = ({ tone, className, children }: VariantProps<typeof statusLabel> & { className?: string; children: ReactNode }) => (
  <span className={statusLabel({ tone, className })}>{children}</span>
)
